'use client';

import React, { useState, useEffect, useRef } from 'react';
import Script from 'next/script';
import {
  useCart,
  useCartAddAttributes,
  useSettings,
} from '@backpackjs/storefront';

export function BeamSelectNonprofitWrapper() {
  const cart = useCart();
  const { cartAddAttributes } = useCartAddAttributes();
  const settings = useSettings();
  const beamSettings = settings?.beam;

  // Optional: state for handling nonprofit selection in app
  const [selectedNonprofit, setSelectedNonprofit] = useState({
    id: null,
    name: null,
  });
  const element = useRef(null);

  const handleNonprofitSelect = async (event) => {
    if (!cart?.id) return;

    const { selectedNonprofitId, nonprofitName, selectionId } = event.detail;
    // Nonprofit details can be displayed in a message, saved on server, etc.
    setSelectedNonprofit({
      name: nonprofitName,
      id: selectedNonprofitId,
    });

    const attributes = {
      beam_cart_id: cart.id,
      beam_chain_id: beamSettings.beamChainId,
      beam_store_id: parseInt(beamSettings.beamStoreId, 10),
      beam_nonprofit_id: selectedNonprofitId,
      beam_selection_id: selectionId,
    };

    // Update your cart with Beam metadata
    await cartAddAttributes({
      attributes: Object.entries(attributes).map(([key, value]) => ({
        key,
        value: value.toString(),
      })),
    });
  };

  useEffect(() => {
    const currentElement = element.current;
    const handler = (e) => handleNonprofitSelect(e);

    if (
      currentElement &&
      cart?.id &&
      beamSettings?.beamStoreId &&
      beamSettings?.beamChainId
    ) {
      currentElement.addEventListener('beamnonprofitselect', handler);
      currentElement.addEventListener('beamnonprofitselect', handler);
    }

    return () => {
      if (currentElement) {
        currentElement.removeEventListener('beamnonprofitselect', handler);
        currentElement.removeEventListener('beamnonprofitselect', handler);
      }
    };
  }, [element, cart?.id, beamSettings?.beamChainId, beamSettings?.beamStoreId]);

  return (
    <>
      <Script
        strategy="afterInteractive"
        type="module"
        crossOrigin="anonymous"
        src="https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/select-nonprofit.esm.js"
      />
      <beam-select-nonprofit
        ref={element}
        apiKey={beamSettings?.beamApiKey}
        chainId={beamSettings?.beamChainId}
        storeId={parseInt(beamSettings?.beamStoreId || 0, 10)}
        class="font-sans"
      />
    </>
  );
}
